import React, { useState } from 'react'
import {useSubscription } from '@apollo/client';

import Container from 'src/components/shared/container';
import {PARCEL_WORKER_TASK } from 'src/graphql/subscription/parcel.subscription';
import { useSelectDate } from 'src/hooks/useSelectDate';
import { useParcelStore } from 'src/store/parcel';

import { WorkerTaskingLive } from '../worker-tasking-live';

type Props={
    workerId:string 
}

const WorkerDetails: React.FC<Props> = ({workerId}) => {

    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const activeParcel= useParcelStore((state)=>state.parcel)

    useSelectDate({ setStartDate, setEndDate });

    const { data, loading, } = useSubscription(PARCEL_WORKER_TASK,
        {variables:{
            id:activeParcel,   
            worker_id:workerId,
            task_start_date: startDate,
            task_end_date: endDate    

       },
       skip:!activeParcel
    });
    const record = data?.parcels_by_pk

    return (
        <Container>
            <div>
            <h1 className='text-xl font-medium'>Tasks</h1>
            </div>
            <WorkerTaskingLive 
            activeParcel={activeParcel}
            zones={record?.zones}
            locationDensity={record?.widget_parcel_location_density}  
            loading={loading}/>
        </Container>
    )
}

export default WorkerDetails
